export const API_PORT = "5000";
// export const API_URL = `http://localhost:${API_PORT}`
export const API_URL = `https://jsonplaceholder.typicode.com`;
export const DOMAIN_TITLE = "Meter";
